jQuery(document).ready(function(){
    jQuery('#check-menu').click(function(){
        jQuery("body").toggleClass('hidden');
    });
    jQuery(window).scroll(function () {
        var height = jQuery(window).scrollTop();

        if (height > jQuery(window).height() / 3) {
            jQuery('body').addClass('show-scroll-btn');
        } else {
            jQuery('body').removeClass('show-scroll-btn');
        }
    });
    jQuery('.tabs').tabs();

    jQuery('.pwa-slider').slick({
        dots: true
    });
    jQuery('.pwa-macos-slider').slick({
        dots: true
    });
    makeHeight();

    document.querySelectorAll('.currency-row').forEach(item => {
        window.addEventListener('load', Marquee(item, 0.5))
    });
    openClose();

    OpenBox({
        wrap: '.openbox',
        link: '.open-btn',
        box: '.openbox-drop',
        openClass: 'open'
    });
});

function Marquee(selector, speed) {
    const parentSelector = selector;
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    parentSelector.insertAdjacentHTML('beforeend', clone);
    parentSelector.insertAdjacentHTML('beforeend', clone);

    setInterval(function () {
        firstElement.style.marginLeft = `-${i}px`;
        if (i > firstElement.clientWidth) {
            i = 0;
        }
        i = i + speed;
    }, 0);
};

function makeHeight(){
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
};

function openClose() {
    var wrap = jQuery('.open-close').each(function () {
        var boxed = jQuery(this);
        var link = boxed.find('.open-close-btn');
        var boxOpen = boxed.find('.open-close-drop');

        boxOpen.css('display', 'none');
        boxed.removeClass('open')
        link.on('click', function (e) {
            if (!boxed.hasClass('open')) {
                boxed.addClass('open');
                boxOpen.slideUp(0).slideDown(400);
            } else {
                boxOpen.slideUp(400, function () {
                    boxed.removeClass('open');
                });
            }
            return false;
        });
    });
};

function OpenBox(obj) {
    jQuery(obj.wrap).each(function () {
        var hold = jQuery(this);
        var link = hold.find(obj.link);
        var box = hold.find(obj.box);
        var w = obj.w;
        var close = hold.find(obj.close);

        link.click(function () {
            //jQuery(obj.wrap).not(hold).removeClass(obj.openClass);
            if (!hold.hasClass(obj.openClass)) {
                hold.addClass(obj.openClass);
            } else {
                hold.removeClass(obj.openClass);
            }
            return false;
        });
        close.click(function () {
            hold.removeClass(obj.openClass);
            return false;
        });
        if (obj.single) {
            link.click(function () {
                jQuery(obj.wrap).not(hold).removeClass(obj.openClass);
            });
            hold.hover(function () {
                jQuery(this).addClass('hovering');
            }, function () {
                jQuery(this).removeClass('hovering');
            });
            jQuery(document).bind('touchstart mousedown', function (e) {
                if (!(jQuery(e.target).parents().index(hold) != -1 || jQuery(e.target).index(hold) != -1)) {
                    hold.removeClass(obj.openClass);
                }
            });
        } else if (obj.openBoxMenu) {
            link.click(function () {
                jQuery(obj.wrap).not(hold).removeClass(obj.openClass);
            });
        }
    });
};